import React from "react";

const TermsOfUse = () => {
  return (
    <div
      className="container-fluid py-5"
      style={{ backgroundColor: "#f9f7f4", minHeight: "100vh" }}
    >
      <div className="px-5">
        <div className="row">
          {/* Left Column (Heading + Intro) */}
          <div className="col-md-5 mb-4">
            <h1
              className="fw-bold mb-4"
              style={{ color: "#6c5243", fontSize: "3rem" }}
            >
              Terms of Use
            </h1>
            <p className="text-secondary" style={{ fontSize: "1.3rem" ,width:'85%'}}>
              At Empowering Beauty, these Terms of Use are designed to ensure a
              professional, safe, and effective training environment. By using
              our platform, both staff and managers agree to uphold these
              standards and practices to support growth, accountability, and
              compliance.
            </p>
          </div>

          {/* Right Column (Sections) */}
          <div className="col-md-7">
            {/* Section 1 */}
           <h4 
            className="fw-semibold mt-4 mb-4 d-flex align-items-center" 
            style={{ color: "#6c5243", gap: "15px" }}
            >
            <span>1</span>
            <span>|</span>
            <span>Introduction</span>
            </h4>
            <p className="text-secondary" style={{ fontSize: "1.3rem" }}>
              These Terms of Use (“Terms”) govern your access to and use of Empowering Beauty (“we,” “our,” “us”) and the training services we provide. By creating an account or using our platform, you agree to comply with these Terms. If you do not agree, you must not use our services.
            </p>

            {/* Section 2 */}
            <h4 
            className="fw-semibold mt-4 mb-4 d-flex align-items-center" 
            style={{ color: "#6c5243", gap: "15px" }}
            >
              
            <span>2</span>
            <span>|</span>
            <span>User Roles</span>
            </h4>
            <ul className="text-secondary" style={{ fontSize: "1.3rem" }}>
                Our platform has two primary roles:
              <li>
                <strong>Staff Users:</strong> Employees or trainees who access the training materials, courses, and resources.
              </li>
              <li>
                <strong>Manager Users:</strong> Supervisors or administrators who oversee staff progress, manage access, and ensure compliance.
              </li>
            </ul>

            {/* Section 3 */}
            <h4 className="fw-semibold mt-4 mb-4 d-flex align-items-center" 
            style={{ color: "#6c5243", gap: "15px" }}>
                <span>3</span>
            <span>|</span>
            <span>Permitted Use</span>
               
            </h4>
            {/* <ul className="text-secondary" style={{ fontSize: "1.3rem" }}> */}
                <p className="text-secondary" style={{ fontSize: "1.3rem" }}>
               Users must access the platform only for legitimate training, learning, or work-related purposes.
            </p>
            <p className="text-secondary mt-2" style={{ fontSize: "1.3rem" }}>
               Accounts are individual and must not be shared.
            </p>
            <p className="text-secondary mt-2" style={{ fontSize: "1.3rem" }}>
               Managers may only access staff information for oversight and compliance purposes.
            </p>
            <p className="text-secondary mt-2" style={{ fontSize: "1.3rem" }}>
             Copying, distributing, or reselling training materials without written consent is strictly prohibited.
            </p>
               
             
            {/* </ul> */}

            {/* Section 4 */}
            <h4 className="fw-semibold mt-4 mb-4 d-flex align-items-center" 
            style={{ color: "#6c5243", gap: "15px" }}>
                
              <span>4</span>
            <span>|</span>
            <span>Misuse & Prohibited Conduct</span>
            </h4>
            <p className="text-secondary" style={{ fontSize: "1.3rem" }}>
              You must not:
            </p>
            <ul className="text-secondary" style={{ fontSize: "1.3rem" }}>
               
              <li>
                Share your login details with others.
              </li>
              <li>
                   Attempt to bypass security, access restricted areas, or interfere with the system.
              </li>
               <li>
                 Use the platform for personal gain outside its intended purpose.
              </li>
               <li>
                Managers: must not misuse their oversight privileges (e.g., accessing data without justification or altering staff records improperly).
              </li>
            </ul>
           

            {/* Section 5 */}
            <h4 className="fw-semibold mt-4 mb-4 d-flex align-items-center" 
            style={{ color: "#6c5243", gap: "15px" }}>
               
              <span>5</span>
            <span>|</span>
            <span>Intellectual Property</span>
            </h4>
            <p className="text-secondary" style={{ fontSize: "1.3rem" }}>
             All course content, training materials, logos, and resources remain the property of Empowering Beauty or its licensors. Users are granted a limited, non-transferable license to access materials for training purposes only.
            </p>

            {/* Section 6 */}
            <h4 className="fw-semibold mt-4 mb-4 d-flex align-items-center" 
            style={{ color: "#6c5243", gap: "15px" }}>
               
              <span>6</span>
            <span>|</span>
            <span>Data & Privacy</span>
            </h4>
            <p className="text-secondary" style={{ fontSize: "1.3rem" }}>
             Your use of the platform is subject to our <a href="https://www.empoweringbeautyau.com/privacy-policy" style={{color: "#6c5243",fontWeight:'500'}}>Privacy Policy</a>. By using our services, you consent to the collection, storage, and use of your information as described in that policy and in accordance with the Privacy Act 1988 (Cth) and other applicable Australian privacy laws.
            </p>

            {/* Section 7 */}
            <h4 className="fw-semibold mt-4 mb-4 d-flex align-items-center" 
            style={{ color: "#6c5243", gap: "15px" }}>
               
              <span>7</span>
            <span>|</span>
            <span>Monitoring & Compliance</span>
            </h4>
            <p className="text-secondary mt-2" style={{ fontSize: "1.3rem" }}>
             We reserve the right to monitor user activity to ensure compliance.


            </p>
            <p className="text-secondary mt-2" style={{ fontSize: "1.3rem" }}>
            Managers are responsible for ensuring their staff follow these Terms.


            </p>
            <p className="text-secondary mt-2" style={{ fontSize: "1.3rem" }}>
             Breaches may result in account suspension or termination.
            </p>

            

            {/* Section 8 */}
            <h4 className="fw-semibold mt-4 mb-4 d-flex align-items-center" 
            style={{ color: "#6c5243", gap: "15px" }}>
               
              <span>8</span>
            <span>|</span>
            <span>Disclaimer & Liability</span>
            </h4>
            <p className="text-secondary" style={{ fontSize: "1.3rem" }}>
             We strive to provide high-quality training, but we do not guarantee that the website will always be error-free or uninterrupted. Use is at your own risk.


            </p>
            <p className="text-secondary mt-2" style={{ fontSize: "1.3rem" }}>
            Nothing in these Terms excludes, restricts, or modifies any consumer guarantees, rights, or remedies you may have under the Australian Consumer Law (ACL), which cannot be excluded by contract.
            </p>


         <h4 className="fw-semibold mt-4 mb-4 d-flex align-items-center" 
            style={{ color: "#6c5243", gap: "15px" }}>
               
              <span>9</span>
            <span>|</span>
            <span>Limitation of Liability</span>
            </h4>
            <p className="text-secondary" style={{ fontSize: "1.3rem" }}>
            
To the extent permitted by law, we are not liable for any indirect, incidental, or consequential damages resulting from the use or inability to use the platform, including loss of data or business interruptions.



            </p>
            <p className="text-secondary mt-2" style={{ fontSize: "1.3rem" }}>
           Our liability for any breach of a condition or warranty implied by law that cannot be excluded is limited, at our option, to:




            </p>
            <p className="text-secondary" style={{ fontSize: "1.3rem" }}>
    the resupply of services, or
            </p>
            <p className="text-secondary" style={{ fontSize: "1.3rem" }}>
            
the cost of having the services supplied again
            </p>
           
            {/* Section 9 */}
            <h4 className="fw-semibold mt-4 mb-4 d-flex align-items-center" 
            style={{ color: "#6c5243", gap: "15px" }}>
               
              <span>10</span>
            <span>|</span>
            <span>Termination</span>
            </h4>
            <p className="text-secondary" style={{ fontSize: "1.3rem" }}>
             We may suspend or terminate your account at any time if you violate these Terms. Upon termination, your right to access the platform immediately ends.
            </p>

            {/* Section 10 */}
            <h4 className="fw-semibold mt-4 mb-4 d-flex align-items-center" 
            style={{ color: "#6c5243", gap: "15px" }}>
               
              <span>11</span>
            <span>|</span>
            <span>Governing Law</span>
            </h4>
            <p className="text-secondary" style={{ fontSize: "1.3rem" }}>
            These Terms are governed by the laws of the Commonwealth of Australia and the laws of the State or Territory in which Empowering Beauty primarily operates. You agree to submit to the exclusive jurisdiction of the courts of that State or Territory.
            </p>

            {/* Section 11 */}
            <h4 className="fw-semibold mt-4 mb-4 d-flex align-items-center" 
            style={{ color: "#6c5243", gap: "15px" }}>
               
              <span>12</span>
            <span>|</span>
            <span>Contact Us</span>
            </h4>
            <p className="text-secondary" style={{ fontSize: "1.3rem" }}>
              For questions or concerns about these Terms, contact us at:{" "}
              <a
                href="mailto:Legal@empoweringbeautyau.com"
                className="text-decoration-underline"
                style={{ color: "#6c5243" }}
              >
                Legal@empoweringbeautyau.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
